import api from '@/api';
import {
  InvoiceGovernmentClassificationTax,
  InvoiceGovernmentClassificationTaxListRequest,
  InvoiceGovernmentClassificationTaxListResponse,
  InvoiceGovernmentCst,
  InvoiceGovernmentCstListRequest,
  InvoiceGovernmentCstListResponse,
  InvoiceGovernmentPresumedCode,
} from './government.types';

const path = '/invoice/v1/government';

export default {
  async cstList(params: InvoiceGovernmentCstListRequest) {
    const result = (await api.get(`${path}/cst`, params)) as unknown;
    return result as InvoiceGovernmentCstListResponse;
  },

  async cstDetail(code?: string) {
    const result = (await api.get(`${path}/cst/${code}`, null)) as unknown;
    return result as InvoiceGovernmentCst;
  },

  async classificationTaxList(
    params: InvoiceGovernmentClassificationTaxListRequest,
  ) {
    const result = (await api.get(
      `${path}/classification-tax`,
      params,
    )) as unknown;
    return result as InvoiceGovernmentClassificationTaxListResponse;
  },

  async classificationTaxDetail(code?: string) {
    const result = (await api.get(
      `${path}/classification-tax/${code}`,
      null,
    )) as unknown;
    return result as InvoiceGovernmentClassificationTax;
  },

  async presumedCodeList() {
    const result = (await api.get(`${path}/presumed-code`, null)) as unknown;
    return result as InvoiceGovernmentPresumedCode[];
  },

  async presumedCodeDetail(code?: string) {
    const result = (await api.get(
      `${path}/presumed-code/${code}`,
      null,
    )) as unknown;
    return result as InvoiceGovernmentPresumedCode;
  },
};
